/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SubtitleEvent,
    SubtitleEventFromJSON,
    SubtitleEventFromJSONTyped,
    SubtitleEventToJSON,
} from './';

/**
 * 
 * @export
 * @interface Subtitle
 */
export interface Subtitle {
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof Subtitle
     */
    info?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof Subtitle
     */
    styles?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {Array<SubtitleEvent>}
     * @memberof Subtitle
     */
    events?: Array<SubtitleEvent>;
}

export function SubtitleFromJSON(json: any): Subtitle {
    return SubtitleFromJSONTyped(json, false);
}

export function SubtitleFromJSONTyped(json: any, ignoreDiscriminator: boolean): Subtitle {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'info': !exists(json, 'info') ? undefined : json['info'],
        'styles': !exists(json, 'styles') ? undefined : json['styles'],
        'events': !exists(json, 'events') ? undefined : ((json['events'] as Array<any>).map(SubtitleEventFromJSON)),
    };
}

export function SubtitleToJSON(value?: Subtitle | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'info': value.info,
        'styles': value.styles,
        'events': value.events === undefined ? undefined : ((value.events as Array<any>).map(SubtitleEventToJSON)),
    };
}


